<template>
  <section class="cliente-detail-section">
    <header class="cliente-detail-section__head">
      <div class="cliente-detail-section__icon" :class="iconClass">
        <slot name="icon" />
      </div>
      <div class="cliente-detail-section__titles">
        <h3 class="cliente-detail-section__title">{{ title }}</h3>
        <p v-if="subtitle" class="cliente-detail-section__subtitle">{{ subtitle }}</p>
      </div>
      <div v-if="$slots.actions" class="cliente-detail-section__actions">
        <slot name="actions" />
      </div>
    </header>
    <div class="cliente-detail-section__body">
      <slot />
    </div>
  </section>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  iconClass: { type: String, default: 'from-purple-500 to-indigo-600' }
})
</script>

<style scoped>
.cliente-detail-section {
  border-radius: 4px;
  border: 1px solid var(--border-primary, #e2e8f0);
  background: var(--bg-secondary, #fff);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.cliente-detail-section__head {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem 1rem 0.75rem;
  border-bottom: 1px dashed var(--border-primary, #e2e8f0);
}
.cliente-detail-section__icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, var(--tw-gradient-stops));
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.cliente-detail-section__icon.from-purple-500.to-indigo-600 {
  --tw-gradient-from: #a855f7;
  --tw-gradient-to: #4f46e5;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.cliente-detail-section__icon.from-orange-500.to-red-600 {
  --tw-gradient-from: #f97316;
  --tw-gradient-to: #dc2626;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.cliente-detail-section__icon.from-emerald-500.to-teal-600 {
  --tw-gradient-from: #10b981;
  --tw-gradient-to: #0d9488;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.cliente-detail-section__icon.from-sky-500.to-blue-600 {
  background: linear-gradient(135deg, #0ea5e9, #2563eb);
}
.cliente-detail-section__icon :deep(svg) {
  width: 1.25rem;
  height: 1.25rem;
  color: #fff;
}
.cliente-detail-section__titles {
  flex: 1;
  min-width: 0;
}
.cliente-detail-section__title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary, #0f172a);
  margin: 0;
}
.cliente-detail-section__subtitle {
  font-size: 0.8125rem;
  color: var(--text-secondary, #64748b);
  margin: 0.125rem 0 0;
}
.cliente-detail-section__actions {
  flex-shrink: 0;
}
.cliente-detail-section__body {
  padding: 1rem;
}
</style>
